import { render, staticRenderFns } from "./core-function-desc.vue?vue&type=template&id=28ac2c38&scoped=true&"
import script from "./core-function-desc.vue?vue&type=script&lang=js&"
export * from "./core-function-desc.vue?vue&type=script&lang=js&"
import style0 from "./core-function-desc.vue?vue&type=style&index=0&id=28ac2c38&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28ac2c38",
  null
  
)

export default component.exports